import React, { useState, useEffect } from "react";
import axios from "axios";
import "./Map.css";

const Map = () => {
  const [fetchedData1, setFetchedData1] = useState([]);
  const [fetchedData2, setFetchedData2] = useState([]);

  const fetchdata1 = async () => {
    try {
      const response1 = await axios.get(
        "https://api.dremerz.net/api/Kalanjiyam_Advertisement_Shopimage1"
      );
      console.log(response1.data, "response.data");
      setFetchedData1(response1.data);
    } catch (error) {
      console.log(error);
    }
  };
  const fetchdata2 = async () => {
    try {
      const response2 = await axios.get(
        "https://api.dremerz.net/api/Kalanjiyam_Advertisement_Shopimage2"
      );
      console.log(response2.data, "response.data");
      setFetchedData2(response2.data);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchdata1();
    fetchdata2();
  }, []);

  return (
    <div className="map-container">
      <div className="breadcrumb">
        <a href="/" className="breadcrumb-link">
          Home
        </a>{" "}
        / <span>ContactUs</span>
      </div>

      <div className="row">
        {/* Left column for Map */}
        <div className="col-4">
          <div className="map-frame">
            <iframe
              title="Google Map"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d9931.726411959067!2d-0.13626716678791893!3d51.50949061686143!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x487604cb62e4a639%3A0x2a63555c9f9a3ae2!2sThe%20National%20Gallery!5e0!3m2!1sen!2suk!4v1698148990017!5m2!1sen!2suk"
              width="100%"
              height="300%"
              style={{ border: 0 }}
              allowFullScreen=""
              loading="lazy"
            ></iframe>
          </div>
        </div>

        {/* Middle column for Image 1 */}
        {fetchedData1?.map((item) => (
          <>
            <div className="col-4">
              <div className="image-frame">
                <img
                  src={`https://api.dremerz.net/uploads/${item.banneradimage}`}
                  alt="Placeholder"
                  width="100%"
                  height="250%"
                  style={{
                    objectFit: "cover",
                    borderRadius: "5px",
                    boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
                  }}
                />
              </div>
            </div>
          </>
        ))}

        {/* Right column for Image 2 */}
        {fetchedData2?.map((item) => (
          <>
            <div className="col-4">
              <div className="image-frame">
                <img
                  src={`https://api.dremerz.net/uploads/${item.banneradimage}`}
                  alt="Placeholder"
                  width="100%"
                  height="250%"
                  style={{
                    objectFit: "cover",
                    borderRadius: "5px",
                    boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
                  }}
                />
              </div>
            </div>
          </>
        ))}
      </div>
    </div>
  );
};

export default Map;
